<!-- AdminLayout.vue -->
<template>
    <div>
      <div class="container-scroller">
        <Headerr @toggleSidebar="toggleSidebar" />
        <div class="container-fluid page-body-wrapper">
          <Sidebar :isOpen="isSidebarOpen" />
          <div class="main-panel">
            <router-view></router-view>
            <Footerr />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Headerr from "../components/superAdminLayout/Header.vue";
  import Sidebar from "../components/superAdminLayout/Sidebar.vue";
  import Footerr from "../components/superAdminLayout/Footer.vue";
  
  export default {
    name: "SuperAdminLayout",
    components: { Headerr, Sidebar, Footerr },
    data() {
      return {
        isSidebarOpen: false,
      };
    },
    methods: {
      toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
      },
    },
    mounted() {},
  };
  </script>
  